import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import EsiInclude from '../esi-include/EsiInclude';
const ServerSideInclude = props => {
    /*
      const configuration = useAemConfig();
      if (configuration.feature_toggles.ssi_available) {
          return <SsiInclude {...props} />
      }
      */
    return _jsx(EsiInclude, Object.assign({}, props));
};
export default memo(ServerSideInclude);
